module.exports = __webpack_public_path__ + "static/pizza28-d82b013d147f5aba6848eeedaa9cbf33.webp";